import { Component } from 'react'
import Cookies from 'js-cookie'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import * as dropdownRepository from 'scripts/api/header/dropdown-menu'
import profile from 'scripts/components/user/profile'

import { HeaderProvider } from '../contexts/HeaderContext'

class HeaderProviderMethods extends Component {
  constructor (props) {
    super(props)

    this.state = {
      dropdownElements: [],
      isLoading: true,
      isLogged: false,
      userResources: {},
      activatedParent: null,
      isExpanded: false,
      isOpened: false,
      isCartDrawerOpen: false,
      toggleMenu: this.toggleMenu,
      toggleMenuSize: this.toggleMenuSize,
      toggleChildren: this.toggleChildren,
      toggleCartDrawer: this.toggleCartDrawer,
      setParentActivated: this.setParentActivated,
      assistedSalesLinks: this.props.assistedSalesLinks && JSON.parse(this.props.assistedSalesLinks),
      isBlackWeekend: this.props.isBlackWeekend
    }

    this.isAssistedSale = Cookies.get('assisted_sale') === '1'
    this.menuElement = null
    this.subMenuElement = null
  }

  async componentDidMount () {
    this.menuElement = document.querySelector('ul.menu-list-mobile-elements')
    this.subMenuElement = document.querySelector('ul.menu-list')

    try {
      const [userResources, dropdownData] = await Promise.all([
        profile.get(),
        this.getMenu()
      ])

      this.setState({
        userResources: userResources,
        isLogged: userResources.email && userResources.email.length > 0,
        dropdownElements: dropdownData.data,
        isLoading: false
      })
    } catch (err) {
      console.error(err)
    }
  }

  getMenu () {
    if (this.isAssistedSale) {
      return dropdownRepository.getMenuVA()
    }

    return dropdownRepository.getMenu()
  }

  setParentActivated = activatedParent => {
    this.setState({ activatedParent })
  }

  toggleChildren = () => {
    this.setState({
      isExpanded: !this.state.isExpanded
    }, () => {
      this.state.isExpanded ? disableBodyScroll(this.subMenuElement) : enableBodyScroll(this.subMenuElement)
    })
  }

  toggleMenu = () => {
    this.setState({
      isOpened: !this.state.isOpened
    }, () => {
      this.state.isOpened ? disableBodyScroll(this.menuElement) : enableBodyScroll(this.menuElement)
    })
  }

  toggleMenuSize = () => {
    this.setState({
      isExpanded: !this.state.isExpanded
    })
  }

  toggleCartDrawer = () => {
    this.setState(prevState => ({
      isCartDrawerOpen: !prevState.isCartDrawerOpen
    }))
  }

  render () {
    return (
      <HeaderProvider value={this.state}>{this.props.children}</HeaderProvider>
    )
  }
}

export default HeaderProviderMethods
